import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, useState } from 'react';
import { BaseLayout } from '@core/layout/BaseLayout';
import { getLogo, parseComponentId } from '@utils';
import { UXPContext } from '@core/context/Context';
import UIView from '@core/views/ui-view/UIView';
import ErrorBoundary from '@helper/ErrorBoundary/ErrorBoundary';
import FloatingActions from '@core/floating-actions/FloatingActions';
const DevUIViewBase = () => {
    const context = useContext(UXPContext);
    const [navigationLinks, setNavigationLinks] = useState({ all: [], top: {}, sidebar: [] });
    const [expandedSidebar, setExpandedSidebar] = useState(true);
    // Read full compound id from URL: ?id=<moduleId>/<componentId> (2-part) or <moduleId>/ui/<componentId> (3-part legacy)
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id') || '';
    const parsed = parseComponentId(id);
    const moduleId = (parsed === null || parsed === void 0 ? void 0 : parsed.moduleId) || '';
    const componentId = (parsed === null || parsed === void 0 ? void 0 : parsed.componentId) || '';
    const loadNavigation = useCallback(() => {
        setNavigationLinks({
            all: [],
            top: {
                ['uxp_dev']: {
                    link: {
                        id: 'uxp_dev',
                        label: 'Experience Portal',
                        icon: '',
                        link: ''
                    },
                    parent: null,
                    children: []
                }
            },
            sidebar: []
        });
    }, []);
    useEffect(() => {
        loadNavigation();
    }, [loadNavigation]);
    const handleSidebarToggle = useCallback(() => {
        setExpandedSidebar(prev => !prev);
    }, []);
    return (_jsxs(BaseLayout, { header: {
            logo: getLogo(context),
            expandedSidebar,
            onToggleSidebar: handleSidebarToggle,
            navigationLinks,
            renderRightSection: _jsx(_Fragment, {})
        }, sidebar: {
            navigationLinks,
            loading: false,
            tools: {
                search: { enable: false, onClick: () => { } },
                marketPlace: { enable: false, url: '' }
            }
        }, children: [_jsx("div", { className: "uxpcore_devuiview__container", children: moduleId && componentId ? (_jsx(UIView, { moduleId: moduleId, componentId: componentId })) : (_jsx("div", { className: "uxpcore_devuiview__error", children: context.$L('uxp-core.text.unable-to-find-the-view') })) }), _jsx(FloatingActions, {})] }));
};
const DevUIView = memo(() => (_jsx(ErrorBoundary, { children: _jsx(DevUIViewBase, {}) })));
export default DevUIView;
